import React from "react";
import classnames from "classnames";
import { Badge } from "@optimizely/axiom";

import styles from "./UserGroupTypeBadge.module.scss";
import { GROUP_TYPES } from "../../../constants/constants";

const BADGE_COLOR_BY_TYPE: Record<string, string> = {
    [GROUP_TYPES.PRODUCT]: "default",
    [GROUP_TYPES.INTERNAL]: "purple"
};

/**
 * A user group's type, badged.
 *
 * Shared so every table that shows a group type reads the same: the groups list and the bulk upload
 * Access panel both use it, and a colour added here shows up in both.
 *
 * A group whose type the API left blank is a custom group — that is the implicit default server-side,
 * so it is labelled as one rather than left empty.
 */
export const UserGroupTypeBadge = ({ groupType, className }: { groupType?: string; className?: string }) => (
    <Badge
        className={classnames(styles["user-group-type-badge"], className)}
        color={BADGE_COLOR_BY_TYPE[groupType ?? ""] ?? "new"}
    >
        {groupType || "Custom"}
    </Badge>
);

UserGroupTypeBadge.displayName = "UserGroupTypeBadge";
